import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { Path, Svg } from "@react-pdf/renderer";
import React from "react";

import { Style } from "@react-pdf/types";

interface FontAwesomeIconProps {
    faIcon: IconDefinition;
    style?: Style;
}

const FontAwesomeIconPDF = ({ faIcon: { icon }, style = {} }: FontAwesomeIconProps) => {
    const paths = Array.isArray(icon[4]) ? icon[4] : [icon[4]];
    const color = style.color || "black";
    return (
        <Svg viewBox={`0 0 ${icon[0]} ${icon[1]}`} style={style}>
            {paths && paths.map((d, index) => <Path d={d} key={index} fill={color} />)}
        </Svg>
    );
};
export default FontAwesomeIconPDF;
